<template>
  <svg viewBox="0 0 20 20" v-on="$listeners">
    <path
      d="M0 2c0-1.1 0.9-2 2-2h16c1.105 0 2 0.895 2 2v0 16c0 1.105-0.895 2-2 2v0h-16c-1.105 0-2-0.895-2-2v0-16zM7 6v2c0 1.657 1.343 3 3 3s3-1.343 3-3v0-2c0-1.657-1.343-3-3-3s-3 1.343-3 3v0zM18 15.14c-2.287-1.345-5.038-2.14-7.975-2.14-0.009 0-0.018 0-0.026 0h0.001c-2.91 0-5.65 0.78-8 2.14v2.86h16v-2.86z"
    ></path>
  </svg>
</template>

<script>
export default {
  name: 'user-solid-square',
}
</script>